import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type RunStatus = 'starting' | 'running' | 'completed' | 'error' | 'crashed' | 'oom_killed' | 'stopped' | 'idle_timeout';

interface StatusConfig {
  label: string;
  className: string;
}

const statusConfig: Record<RunStatus, StatusConfig> = {
  starting: {
    label: 'Starting',
    className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
  },
  running: {
    label: 'Running',
    className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
  },
  completed: {
    label: 'Completed',
    className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  },
  error: {
    label: 'Error',
    className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  },
  crashed: {
    label: 'Crashed',
    className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  },
  oom_killed: {
    label: 'OOM Killed',
    className: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400',
  },
  stopped: {
    label: 'Stopped',
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400',
  },
  idle_timeout: {
    label: 'Idle Timeout',
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400',
  },
};

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status as RunStatus] || {
    label: status,
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400',
  };

  return (
    <Badge
      variant="outline"
      className={cn('border-0', config.className, className)}
    >
      {config.label}
    </Badge>
  );
}
